/** @typedef {'ttb-web' | 'ttb-native'} MobileWebBridgeSource */

/** @typedef {'ready' | 'goBack' | 'navigateNative' | 'navigateWeb' | 'openHub'} MobileWebBridgeType */

/**
 * @typedef {Readonly<{
 *   source: MobileWebBridgeSource,
 *   type: MobileWebBridgeType,
 *   governanceKey?: string,
 *   params?: Record<string, unknown>,
 *   webPath?: string,
 *   titleKey?: string,
 * }>} MobileWebBridgeMessage
 */

export const MOBILE_WEB_BRIDGE_SOURCE_WEB = "ttb-web";
export const MOBILE_WEB_BRIDGE_SOURCE_NATIVE = "ttb-native";

/**
 * @param {unknown} raw
 * @returns {MobileWebBridgeMessage | null}
 */
export function parseMobileWebBridgeMessage(raw) {
  let data = raw;
  if (typeof raw === "string") {
    try {
      data = JSON.parse(raw);
    } catch {
      return null;
    }
  }
  if (!data || typeof data !== "object") return null;

  const source = String(data.source || "").trim();
  const type = String(data.type || "").trim();
  if (source !== MOBILE_WEB_BRIDGE_SOURCE_WEB) return null;
  if (!type) return null;

  /** @type {MobileWebBridgeMessage} */
  const msg = {
    source: MOBILE_WEB_BRIDGE_SOURCE_WEB,
    type: /** @type {MobileWebBridgeType} */ (type),
  };

  if (data.governanceKey != null) {
    msg.governanceKey = String(data.governanceKey).trim();
  }
  if (data.webPath != null) {
    msg.webPath = String(data.webPath).trim();
  }
  if (data.titleKey != null) {
    msg.titleKey = String(data.titleKey).trim();
  }
  if (data.params && typeof data.params === "object") {
    msg.params = /** @type {Record<string, unknown>} */ (data.params);
  }

  return msg;
}

/**
 * @param {MobileWebBridgeType} type
 * @param {Omit<MobileWebBridgeMessage, 'source' | 'type'>} [fields]
 * @returns {string}
 */
export function serializeMobileWebBridgeMessage(type, fields = {}) {
  return JSON.stringify({
    source: MOBILE_WEB_BRIDGE_SOURCE_WEB,
    type,
    ...fields,
  });
}
